import React, {useRef} from 'react';
import {View, Modal, Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import Text from '../../elements/Text';
import CalendarView from '../../elements/CalendarView';
import Divider from '../../elements/Divider';
import Button from '../../elements/Button';

import {BUTTON_TYPES} from '../../../utils/Constants';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import CommonStyles from '../../../utils/CommonStyles';
import {tID} from '../../../utils/TestIdHelper';

const NotesCalendar = ({visible, selectedDate, onClose}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const selectedDateRange = useRef(null);

  const onSelectDateRange = fromDate => {
    selectedDateRange.current = fromDate;
  };

  return (
    <Modal
      testID={tID('NotesCalendar-Modal-Main')}
      transparent
      visible={visible}
      onRequestClose={() => onClose(false)}
      animationType="slide">
      <View
        testID={tID('NotesCalendar-View-Container')}
        style={[
          styles.container,
          Platform.OS === 'web' && styles.webContainer,
        ]}>
        <SafeAreaView
          style={[
            styles.safeareaContainer,
            Platform.OS === 'web' && styles.detailsContainer,
          ]}>
          <View style={styles.bottomContainer}>
            <Text
              testID={tID('NotesCalendar-Text-Title')}
              variation="Headline4Bold"
              style={Platform.OS === 'web' && CommonStyles.text_center}>
              Measurement Date
            </Text>
            <View style={styles.marginTop24}>
              <CalendarView
                selectedDate={selectedDate}
                isSingleSelect
                disabled={false}
                onSelectDate={onSelectDateRange}
              />
            </View>
            <Divider top={16} />
            <View style={styles.buttonsContainer}>
              <Button
                testID={tID('NotesCalendar-Button-Cancel')}
                style={[styles.button]}
                buttonType={BUTTON_TYPES.Bordered}
                title={'Cancel'}
                onPress={() => onClose(false)}
              />
              <Button
                testID={tID('NotesCalendar-Button-Confirm')}
                style={[styles.button, styles.ml16]}
                buttonType={BUTTON_TYPES.Filled}
                titleColor={colors.textOnAccent}
                title={'Confirm'}
                onPress={() => onClose(selectedDateRange.current)}
              />
            </View>
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  );
};

export default NotesCalendar;
